import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { HierarchyTree } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { isEqual, getHomepageUrl } from '@as-react/common-utils';
import { Link } from '@yonderland/andes-react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useCategoryHierarchyTree } from '../../../../hooks/useCategoryHierarchyTree';
import { makeGetCategoryHierarchyTree } from '../../../../redux/lister/selectors/ListerSelector';
import { makeGetUrlFilters } from '../../../../redux/url/selectors/UrlSelectors';
import { concatUrls } from '../../../../util/UrlUtil';
import { CategoryHierarchyTreeMobileHelper } from './CategoryHierarchyTreeMobileHelper';
const CATEGORY_HIERARCHY_TREE_BANNER_ID = 'product-lister-category-tree';
/**
 * @deprecated
 */
export const CategoryHierarchyTree = () => {
    const { isInAuthorMode, root, rootWithLanguageSuffix, lang } = useAemConfig();
    const categoryTree = useSelector(makeGetCategoryHierarchyTree());
    const defaultFilter = useSelector(makeGetUrlFilters()).defaultFilter;
    const { categoryIds, categoryHierarchyTree } = useCategoryHierarchyTree(categoryTree, defaultFilter);
    const getUrl = (categoryPath) => concatUrls(isInAuthorMode ? rootWithLanguageSuffix : root, getHomepageUrl(categoryPath));
    const renderHierarchyTreeItem = useCallback((item, _, parents) => {
        var _a;
        const translatedProperty = (_a = item.categoryTranslatedProperties) === null || _a === void 0 ? void 0 : _a[lang.toLocaleUpperCase()];
        if (isEqual(categoryIds, [...parents.map(parent => parent.categoryId), item.categoryId])) {
            return (_jsx(Link, { href: getUrl(translatedProperty.link), testId: "category-link", children: translatedProperty.description }));
        }
        return (_jsx(Link, { href: getUrl(translatedProperty.link), variant: "tertiary", testId: "category-link", children: translatedProperty.description }));
    }, [categoryHierarchyTree, categoryIds]);
    if (!categoryHierarchyTree) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(CategoryHierarchyTreeMobileHelper, { categoryIds: categoryIds, hierarchyTree: categoryHierarchyTree }), _jsx("div", { "data-analytics-bannerid": CATEGORY_HIERARCHY_TREE_BANNER_ID, children: _jsx(HierarchyTree, { hierarchyTree: categoryHierarchyTree, renderItem: renderHierarchyTreeItem }) })] }));
};
